import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { BrandProvider, ACO_BRAND_CONFIG, BULLSEYE_BRAND_CONFIG } from '@aco/shared';
import { GameProvider } from './context/GameContext.js';
import { AuthProvider, useAuth } from './context/AuthContext.js';
import { StandaloneLobby } from './pages/StandaloneLobby.js';
import { GamePage } from './pages/GamePage.js';
import { AuthSuccessPage } from './pages/AuthSuccessPage.js';
import { configureApiAuth } from './services/api.js';

// Brand is selected via env var — defaults to 'aco'
const BRAND_ID = import.meta.env.VITE_BRAND_ID ?? 'aco';
const brandConfig = BRAND_ID === 'bullseye' ? BULLSEYE_BRAND_CONFIG : ACO_BRAND_CONFIG;

/**
 * Inner component that wires the AuthContext token into the api.ts module.
 * Must be inside <AuthProvider> to call useAuth().
 */
function ApiAuthConnector() {
  const { accessToken, refresh } = useAuth();
  useEffect(() => {
    configureApiAuth(() => accessToken, refresh);
  }, [accessToken, refresh]);
  return null;
}

export function App() {
  return (
    <AuthProvider>
      <BrandProvider config={brandConfig}>
        <GameProvider>
          <BrowserRouter>
            <ApiAuthConnector />
            <Routes>
              <Route path="/" element={<StandaloneLobby />} />
              <Route path="/game/:gameId" element={<GamePage />} />
              <Route path="/auth/success" element={<AuthSuccessPage />} />
              {/* Catch-all → lobby */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </GameProvider>
      </BrandProvider>
    </AuthProvider>
  );
}
